<div class="gallery-container location loc-pg" id="location">
  <h1 class="headline font-weight-bold"
    style="margin-bottom: 20px; text-align: center; margin-bottom: 20px;font-size: 28px;font-weight: 700;margin-bottom: 20px;color: #333333;text-transform: uppercase;letter-spacing: 1px;">
    Locations</h1>
  <div
    style="margin-bottom: 2px; display: flex; flex-wrap: wrap; justify-content: space-between; gap: 20px;">
    <!-- First Location -->
    <div style="flex: 1; min-width: 300px; max-width: 48%; height: 600px; position: relative;" class="loc">
      <!-- The iframe -->
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120400.97754900219!2d85.73771431247633!3d20.257359452917008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a19a7e6a5ba7bc5%3A0xa60388ba8170c0f!2s223%2F2751%2C%20near%20Bijupatnaik%20international%20Airport%2C%20Forest%20Park%2C%20Bhubaneswar%2C%20Odisha%20751020!3m2!1d20.2573968!2d85.82008859999999!5e1!3m2!1sen!2sin!4v1745404605277!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>

      <div class="card map-card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px; width: 80%;">
        <h3>The Greenstar Inn (Near Biju Pattnaik Airport, Bhubaneswar)</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
          us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i>8249093974
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i>thegreenstarinnreservation@gmail.com
        </p>
      </div>
    </div>
    <!-- Second Location -->
    <div style="flex: 1; min-width: 300px; max-width: 48%; height: 600px; position: relative;" class="loc">
      <!-- The iframe -->
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120378.19179677487!2d85.69185061330124!3d20.286719129844172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a1908005db4540f%3A0x17712c89ce12b1fc!2sPlot%20No-789%2F1328%2C%20near%20Sum%20Hospital%20Road%2C%20Durga%20Madhab%20Nagar%2C%20Shampur%2C%20Bhubaneswar%2C%20Odisha%20751003!3m2!1d20.2867384!2d85.7742523!5e1!3m2!1sen!2sin!4v1745405892828!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
      <div class="card map-card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px; width: 80%;">
        <h3>The Greenstar Inn Premium (Near Sum Hospital , Bhubaneswar)</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
          us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i>8249093974
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i>thegreenstarinnreservation@gmail.com
        </p>
      </div>
    </div>
  </div>
</div>
